const initialState = {
    trans: [],
    title: '',
    fromDate: '', 
    startTime: '',
    toDate: '', 
    endTime: '',
    branchOptions: [],
    branchSelect: null,
    cashierOptions: [],
    cashierSelect: null,
};

const trans = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_TRANS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default trans;
